'use client'

import Image from 'next/image'
import { type FC } from 'react'

import { useCdnMediaServer } from '../../../cdn'

type StoryblokPageListItemImageProps = {
  alt: string
  src: string
}

export const StoryblokPageListItemImage: FC<
  StoryblokPageListItemImageProps
> = ({ src, ...rest }) => {
  const { setMediaServerOrigin } = useCdnMediaServer()

  return (
    <Image
      className="rounded-m object-cover"
      fill
      src={setMediaServerOrigin(src)}
      unoptimized
      {...rest}
    />
  )
}
